import type {DefaultError} from "@tanstack/react-query";
import type {UrlQueryKey} from "~/query/queryClient.ts";
import {useCustomQuery} from "~/query/queryClient.ts";
import type {ContractParent} from "./contractCoverageData";

export type ContractCoverageIntelligenceResponse = {
    parent_suppliers_list: ContractParent[];
};

// TODO: @farbod which one is the correct file here? Should there be 8 or 1221 parent suppliers?
// export const CONTRACT_COVERAGE_INTELLIGENCE_URL = "/showcase/contract_coverage/contract_coverage_intelligence/";
export const CONTRACT_COVERAGE_INTELLIGENCE_URL = "/showcase/contract_coverage/cci_parents/";

export const CONTRACT_PARENTS_QUERY_KEY = [
    CONTRACT_COVERAGE_INTELLIGENCE_URL,
] as const satisfies UrlQueryKey;

/**
 * Fetches parent suppliers for Contract Coverage Intelligence.
 * API uses `name` for the parent supplier label (maps to {@link ContractParent.name}).
 */
export function useContractParentsQuery() {
    return useCustomQuery<
        ContractCoverageIntelligenceResponse,
        DefaultError,
        ContractParent[],
        typeof CONTRACT_PARENTS_QUERY_KEY
    >({
        queryKey: CONTRACT_PARENTS_QUERY_KEY,
        select: data => data.parent_suppliers_list ?? [],
    });
}
